import * as ExcelJs from 'exceljs';

export function MakeUniqueSheetName(workbook: ExcelJs.Workbook, desiredName: string): string {
  const MAX_LEN = 31;

  const existing = new Set(workbook.worksheets.map((ws) => ws.name));
  const base = desiredName.slice(0, MAX_LEN);

  if (!existing.has(base)) {
    return base;
  }

  let i = 1;
  while (true) {
    const suffix = `(${i})`;
    const trimmedBase = desiredName.slice(0, MAX_LEN - suffix.length);
    const candidate = `${trimmedBase}${suffix}`;

    if (!existing.has(candidate)) {
      console.warn(`Sheet name "${base}" already exists. Using "${candidate}" instead.`);
      return candidate;
    }
    i++;
  }
}
